import { useEffect } from 'react';
import { ensureMathRenderer } from '../utils/mathRenderer';

export const useArticleMath = ({ articleHtml, contentRef, status }) => {
  useEffect(() => {
    if (status !== 'success' || !articleHtml) {
      return undefined;
    }

    let cancelled = false;

    const renderMath = async () => {
      try {
        await ensureMathRenderer();
        if (cancelled) {
          return;
        }
        if (typeof window === 'undefined' || typeof window.renderMathInElement !== 'function') {
          return;
        }
        if (!contentRef.current) {
          return;
        }
        window.renderMathInElement(contentRef.current, {
          delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '$', right: '$', display: false },
          ],
          throwOnError: false,
          ignoredTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
        });
      } catch (_error) {
        return;
      }
    };

    renderMath();

    return () => {
      cancelled = true;
    };
  }, [articleHtml, contentRef, status]);
};
